/* eslint-disable */
import { useEffect,useContext, useState } from 'react';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Avatar,
  Box,
  Divider,
  Drawer,
  Hidden,
  List,
  Typography,styled
} from '@mui/material';
import TreeItem from '@mui/lab/TreeItem';
import TreeView from '@mui/lab/TreeView';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { UserContext } from '../providers/UserProvider';
import {
  getSiteIdFromURL,
  getSiteWithId
} from 'src/utils/miscTools';
import NavItem from './NavItem';


const infoDisplay = {
  photo: '/static/images/pennStateDish.jpg',
  subTitle: '',
  name: ''
};

const items = [
  {
    href: '/app/dashboard',
    //icon: dashboardIcon,
    title: 'Dashboard'
  }
];


const DashboardSidebar = (props) => {
  const {
    sites,
    onMobileClose,
    openMobile,
    authUser,
    fleetInfo
  } = props;



  const location = useLocation();
  const navigate = useNavigate();
  let isAdmin = false;
  if (authUser.role === 'ADMIN') {
    isAdmin = true;
  }

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }

  }, [location.pathname]);

  function handleClick(url) {
    navigate(url);
    const fullUrl = window.location.href;
    const siteId = getSiteIdFromURL(fullUrl);
    const site = getSiteWithId(siteId, fleetInfo);
    infoDisplay.name = site.siteName;
  }

  const SidebarWrapper = styled('div')(
  ({ theme }) => ({
    width:'200px',
    display: 'block',
    flex: '1 1 auto',
    overflow: 'hidden',
    marginTop:'97px'
  })
);

  const content = (
    <SidebarWrapper>
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          py: 2
        }}
      >
        <Avatar
          component={RouterLink}
          src={infoDisplay.photo}
          sx={{
            cursor: 'pointer',
          }}
          to="/dashboard/account"
        />
        <Typography
          color="textPrimary"
          variant="h5"
        >
          {infoDisplay.name}
        </Typography>
        <Typography
          color="textSecondary"
          variant="body2"
        >
          {authUser ? <b>{authUser.displayName}</b> : <b>Not signed in</b>}
          <br />
          {infoDisplay.subTitle}
        </Typography>
      </Box>
      <Box sx={{ p: 2 }}>
        <Divider />
        <List>
          {sites.map((site) => (
            <NavItem
              href={site.href}
              key={site.title}
              title={site.title}
            />
          ))}
          {isAdmin
            ? (
              <NavItem
                href="/app/controlPanel"
                key="Control Panel"
                title="Control Panel"
                //icon={ToolIcon}
              />
            ) : (<></>)}
        </List>
      </Box>
      <Divider />
    </SidebarWrapper>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
          PaperProps={{
            sx: {
              width: 256
            }
          }}
        >
          {content}
        </Drawer>
      </Hidden>
      <Hidden  lgDown>
        <Drawer 
          style={{ zIndex: 0}}
          anchor="left"
          hidebackdrop='true'
          open
          variant="persistent"
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
};

DashboardSidebar.propTypes = {
  sites: PropTypes.array,
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool,
  authUser: PropTypes.object,
};


DashboardSidebar.defaultProps = {
  onMobileClose: () => { },
  openMobile: false
};

export default DashboardSidebar;
